// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Ocorrencias_HealthCheckResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /ocorrencias/healthCheck
 *
 * Proxy to occurrences-service (Go microservice). The upstream's
 * `healthCheck` handler calls `ctx.Success(true)` so `Data` is a bool;
 * the controller emits this contract on success and `sendError()` on
 * failure (model returns false → controller short-circuits).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Ocorrencias_HealthCheckResponseDados = boolean;

export type Ocorrencias_HealthCheckResponse = ApiResponse<Ocorrencias_HealthCheckResponseDados>;

registerResponseContract('Ocorrencias_HealthCheckResponse', {})
